import React, {useEffect, useState} from 'react';
import { Flex} from "antd";
import {RentTypeTag} from "../../../../../shared";
import {GiMoneyStack} from "react-icons/gi";
import {StyledCard} from "./DetailCards.styled";
import style from "./DetailCards.module.scss";
import {
    LeftOutlined
} from '@ant-design/icons';
import PricePopUp from "../pricePopUp/PricePopUp";
import {PriceCardProps} from "../../../models";
const PriceCard = ({product} : PriceCardProps) => {
    const [open, setOpen] = useState<boolean>(false)
    const [activePrice, setActivePrice] = useState<any>()

    useEffect(() => {
        product?.length > 0 &&  setActivePrice(product.reduce((minItem:any, item:any) => item.pricingMethodId < minItem.pricingMethodId ? item : minItem, product[0]))
    }, [product]);

    const openPriceModal = () => {
        setOpen(true)
    }
    const onCansel = () => {
        setOpen(false)
    }

    return (
    <>        <StyledCard className={'shadow-sm'} onClick={openPriceModal}  >
            <Flex justify={"space-between"} align={"center"}>
                <Flex gap={"middle"}>
                   <span> <GiMoneyStack className={style.icons}/> قیمت </span>
                    <RentTypeTag title={activePrice?.title}/>
                </Flex>
                <Flex gap={"small"}>
                    {product?.length > 1 ?
                        <span
                            className={style.greyText}>{`${activePrice?.price.toString().replace(
                            /\B(?=(\d{3})+(?!\d))/g,
                            ","
                        )} ت و ${product?.length - 1} مورد دیگر`}</span>
                        :
                        <span className={style.greyText}>{activePrice?.price.toString().replace(
                            /\B(?=(\d{3})+(?!\d))/g,
                            ","
                        )} ت</span>
                    }

                    <span> <LeftOutlined className={style.icons}/> </span>
                </Flex>

            </Flex>
    </StyledCard>
        <PricePopUp onConfirm={(id:string)=> {
            onCansel()
        }} product={product} open={open} onCansel={onCansel}/>
    </>

);
};

export default PriceCard;
